import React from 'react'
import {ReactComponent as Plus} from '../../../../images/main/plus.svg'
import {ReactComponent as Minus} from '../../../../images/main/minus.svg'
import styles from './styles.module.scss'

const UsefulInformation = () => {
  const [activeField, setActiveField] = React.useState(0)
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div>
          <p className={styles.title}>
            Факты о Generium
          </p>
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.title}>Вопросы и ответы</p>
        {/* <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(1))}
              className={
                activeField === 2 || activeField === 3 || activeField === 4
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Почему компания организовала производство в Вольгинском?
            </p>
            {activeField === 1 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(1)}/>
            )}
          </div>
          {activeField === 1 && (
            <p className={styles.answer}>
              Generium построил свой производственный цех на базе Покровского завода биопрепаратов. Одновременно с этим
              во Владимирской области начал формироваться фармацевтический кластер. В регионе продолжили развиваться
              исследовательские центры и появились новые производственные площадки.
            </p>
          )}
        </div> */}

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(2))}
              className={
                activeField === 1 || activeField === 3 || activeField === 4
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Существует ли возможность карьерного роста?
            </p>
            {activeField === 2 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(2)}/>
            )}
          </div>
          {activeField === 2 && (
            <p className={styles.answer}>
              Мы заинтересованы в том, чтобы наши сотрудники развивались и росли вместе с компанией, разделяя наши приоритеты, стремления и ценности.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(3))}
              className={
                activeField === 2 || activeField === 1 || activeField === 4
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Есть ли дополнительное профессиональное обучение?
            </p>
            {activeField === 3 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(3)}/>
            )}
          </div>
          {activeField === 3 && (
            <p className={styles.answer}>
              Да, после полугода работы. В компании действует система повышения квалификации сотрудников.<br/>
              Обучение проводится внешними и внутренними экспертами и направлено на повышение эффективности выполнения профессиональных задач.<br/>
              Также в компании есть возможность изучения иностранных языков при производственной необходимости. 
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(4))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Компания помогает с написанием и защитой диссертации?
            </p>
            {activeField === 4 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(4)}/>
            )}
          </div>
          {activeField === 4 && (
            <p className={styles.answer}>
              Да, Generium поддерживает молодых ученых. Вы можете использовать научное оборудование и материалы компании по договоренности с руководителем.
              <br/> Мы также поможем вам с поиском диссертационного совета.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default UsefulInformation
